import Typewriter from "typewriter-effect";

function Type() {
  return (
    <div style={{ display: "inline-block", textAlign: "center", width: "100%" }}>
      <Typewriter
        options={{
          strings: [
            "creative_technologist",
            "forward_deployed_engineer",
            "solutions_engineer",
            "technical_consultant",
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 50,
        }}
      />
    </div>
  );
}

export default Type;
